import { render } from "./TheHeader.vue?vue&type=template&id=1de3c044"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=1de3c044&lang=css"

import exportComponent from "C:\\Users\\griff\\source\\repos\\Owen Associates\\Owen Associates\\Owen_Interiors\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__